import { motion } from "framer-motion";
import { FaGoogle, FaStar, FaArrowRight } from "react-icons/fa";

const GoogleReviews = () => (
    <section data-testid="google-reviews-section" className="relative py-16 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="relative p-8 sm:p-12 rounded-[2rem] bg-gradient-to-br from-white to-brand-50 dark:from-slate-900 dark:to-slate-950 border border-slate-200 dark:border-slate-800 shadow-xl overflow-hidden"
            >
                <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-brand-500/15 blur-3xl" />
                <div className="relative grid sm:grid-cols-2 gap-8 items-center">
                    <div>
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-xs font-semibold">
                            <FaGoogle className="text-blue-500" /> Verified Google Reviews
                        </div>
                        <div className="mt-5 flex items-end gap-3">
                            <div className="font-heading text-6xl font-extrabold text-slate-900 dark:text-white">5.0</div>
                            <div className="pb-2">
                                <div className="flex gap-1">
                                    {[...Array(5)].map((_, i) => <FaStar key={i} className="text-amber-400 text-lg" />)}
                                </div>
                                <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">from 120+ reviews</div>
                            </div>
                        </div>
                        <p className="mt-4 text-slate-600 dark:text-slate-300">Consistently rated 5-star by hospitals, clinics and diagnostic centres across Puducherry.</p>
                    </div>
                    <div>
                        <a
                            href="https://www.google.com/search?q=Ezhil+Biomedical+Sales+and+Services+Puducherry"
                            target="_blank" rel="noopener noreferrer"
                            data-testid="google-reviews-cta"
                            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-gradient-to-r from-brand-700 to-brand-500 text-white font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
                        >
                            Read All Reviews <FaArrowRight />
                        </a>
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);

export default GoogleReviews;
